import { IconProps } from "rivals/components/shared/Icons/iconPropsTypes";

function Facebook({ style }: IconProps): JSX.Element {
  return (
    <svg
      fill="none"
      height="31"
      style={style}
      viewBox="0 0 30 31"
      width="30"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_7981_7686)">
        <circle cx="15" cy="15.5" fill="#0866FF" r="15" />
        <path
          d="M13.4831 22.9731V15.9039H11.1133V13.5206H13.4831V11.1508C13.4831 9.35996 14.9373 8 17.4284 8H19.0038V10.3564H17.4149C16.9941 10.3663 16.5928 10.5361 16.2927 10.8312C15.9926 11.1263 15.8161 11.5247 15.7991 11.9452V13.5206H18.9499L18.2093 15.9039H15.7991V23H13.4831V22.9731Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_7981_7686">
          <rect
            fill="white"
            height="30"
            transform="translate(0 0.5)"
            width="30"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export default Facebook;
